import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isEmpty, map, forEach, isNil, cloneDeep, find } from 'lodash';

import { Col, Row, Space } from 'antd';
import { Button } from '@life-line-lab/components-react';
import Icon, {
  ArrowRightOutlined
} from '@ant-design/icons';

import './product-listing-new.scss';
import { useRecoilState } from 'recoil';
import { toaster, generateCode } from 'Helpers/index';
import { LocalCartAtom } from 'Recoil/order.atom';
import useSession from 'Hooks/session.hook';
import { Alert } from 'antd';
import LoginForm from 'Components/auth/login-form';
import { Tabs, BasicModal } from '@life-line-lab/components-react';
import { authBusinessAccountLogin, authLogin } from 'Services/auth.services';
import { authActionStatusAtom, authPassportAtom, authErrorAtom, isAuthAtom } from 'Recoil/auth.atom';
import {Helmet} from "react-helmet";
import ProductPricing from '../product-pricing';

interface Product {
  imageUrl: string;
  name: string;
  price: string;
  discountPrice?: string;
  href: string;
  percentOff?: number;
  disablePurchase?: boolean;
  stockLimit?: number;
  supplierLocation?: string;
  productType?: string;
  displayType: 'strike' | 'saved'
}

interface ProductListingProps {
  product: any,
  grid?: 4 | 5 | 6
}

const ProductListingNew: React.FC<ProductListingProps> = ({ product, grid = 6 }) => {
  const history = useHistory();
  const { t } = useTranslation();
  // const [isAuth, setIsAuth] = useRecoilState<boolean>(isAuthAtom);
  const [localCartState, setLocalCartState] = useRecoilState<any>(LocalCartAtom);
  const [weightValidation, setWeightValidation] = useState(false);
  const [replacementImg, setReplacementImg] = useState<any>([]);
  const { profile } = useSession();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loginStatus, setLoginStatus] = useRecoilState<any>(authActionStatusAtom);
  const [loginError, setLoginError] = useRecoilState<any>(authErrorAtom);
  const [, setAuthPassport] = useRecoilState<any>(authPassportAtom);

  useEffect(() => {
    let imageList = map(cloneDeep(product.productImages), (imageObj, i) => {
      if (!imageObj.feature) {
        return imageObj;
      }
    })
    setReplacementImg(imageList);
  }, [product.productImages])

  const handleSubmit = async ({ email, password, accountType }) => {

    setLoginStatus({ ...loginStatus, login: 'loading' });

    if (accountType === 'INDIVIDUAL_ACCOUNT') {
      const responseData: any = await authLogin({ email, password });

      if (!isNil(responseData.error)) {
        setLoginStatus({ ...loginStatus, login: 'error' });
        setLoginError(responseData?.error);
      } else {
        setLoginStatus({ ...loginStatus, login: 'success' });
        setAuthPassport(responseData);
        // setIsAuth(true)
        // history.push('/');
      }
    } else if (accountType === 'BUSINESS_ACCOUNT') {
      const responseData: any = await authBusinessAccountLogin({ email, password });

      if (!isNil(responseData.error)) {
        setLoginStatus({ ...loginStatus, login: 'error' });
        setLoginError(responseData?.error);
      } else {
        setLoginStatus({ ...loginStatus, login: 'success' });
        setAuthPassport(responseData);
        // setIsAuth(true)
        // history.push('/');
      }
    }
  }

  const onBuyNow = (productData) => {
    const session = useSession();
    if (isEmpty(session)) {
      onOpenModal();
    } else {
      // let productData = products[i].productData;

      let productUOMs: any = {};
      if (!isEmpty(productData.product?.baseUOM)) {
        productUOMs[productData.product?.baseUOM.uom] = productData.product?.baseUOM.weight?.value || "0"
        forEach(productData.product?.stockUOMs, uomObj => {
          productUOMs[uomObj.uom] = uomObj.weight?.value || "0"
        })
      }

      let itemWeight = productData.stockVariants[0]?.weight?.value ?? productData.stockVariants[0]?.weight ??
        productUOMs[productData.stockVariants[0].uom];

      let productType = productData.product.productType;

      let cartDetails = {
        cartID: generateCode('CRT-'),
        productData: productData,
        selectedVariant: productData.stockVariants[0],
        variantImg: find(productData.productImages, (variant) => {
          return variant.variantCode === productData.stockVariants[0].variantCode
        })?.image || productData.featuredImage?.image || '/assets/images/product-placeholder.png',
        productType: productType,
        quantity: 1,
        weight: productType != 'VOUCHER' ? parseFloat(itemWeight) : 0
      }

      let totalWeight = parseFloat(itemWeight)

      if (totalWeight <= 28) {
        let costObj = {
          orders: [
            {
              supplierID: productData.orgID,
              state: profile.primaryAddress.state,
              weight: parseFloat(itemWeight)
            }
          ]
        }

        setLocalCartState({
          ...localCartState, list: [cartDetails], fromBuyNow: true, shippingCostObj: costObj
        });
        history.push('/checkout');
      } else {
        setWeightValidation(true)
        setTimeout(() => {
          setWeightValidation(false)
        }, 5000);
      }
    }
  }

  const onOpenModal = () => {
    setIsOpen(true);
  }

  const onCloseModal = () => {
    setIsOpen(false);
  }

  const regularPrice = product.productData.stockVariants[0]?.value ?
    '' + product.productData.stockVariants[0]?.value :
    '';
  const srpPrice = product.productData.stockVariants[0]?.ssrPrice ?
    '' + product.productData.stockVariants[0]?.ssrPrice :
    '';

  return (
    <>
      {/*<Helmet>
        <title>Products</title>
        <meta name="description" content={product.name}/>
      </Helmet>*/}
      <Helmet>
        <title>Products</title>
        <meta name="description" content={product.name}/>
      </Helmet>
      <div className="product-listing-new--item">

      {product ?
        <div>


          <Row className="product-listing-new--item-inner" gutter={8}>

            <Col
              className="product-image"
              span={24}
              onClick={() => history.push(product.href)}
            >
              {product.productType == 'VOUCHER' ?
                <span className="custom-badge dark-pink">VOUCHER</span> : null}
              <div className="product-image--image"
                style={{ backgroundImage: `url(${product.imageUrl ? product.imageUrl : replacementImg[0]?.image || '/assets/images/product-placeholder.png'})` }}
                title={product.name}
              />

            </Col>
            <Col
              // className={`product-details ${grid === 2 ? '' : 'text-center'}`}
              className="product-details"
              span={24}
            >
              <div className="product-details--price-container">
                <div className="product-details--name">{product.name}</div>
                {/* <div className="product-details--price">
                  RM {product.discountPrice || product.price}
                </div> */}

                <ProductPricing
                  regularPrice={regularPrice}
                  srpPrice={srpPrice}
                  variant='sm'
                  pricePrefix='RM '
                />
                {/*{product.displayType === 'saved' &&
                (product.discountPrice || product.discounted === 0) &&
                <div className="product-details--discounted">
                  {t('txt.saveAmount', {amount: `RM ${product.discounted}`})}
                </div>
                }

                {product.displayType === 'strike' &&
                (product.discountPrice || product.discounted === 0) &&
                <div className="product-details--strike-price">
                  RM {product.price}
                </div>
                }*/}
              </div>

              {product.supplierLocation ?
                <Row gutter={16}>
                  <Col span={24}>
                    <span className="product-details--location flex-justify-end">
                      <img src='/assets/images/location.svg'
                        width={15} />&nbsp;{product.supplierLocation}
                    </span>
                  </Col>
                </Row>
                :
                null
              }
            </Col>
          </Row>
          <div className="product-details--actions">
            <Row align="middle" justify="center" gutter={16}>
              <Col span={12} className="bg-primary flex-justify-center"
                style={{ padding: '5px', minHeight: 42 }}>
                <Button
                  type="transparent"
                  className="transparent"
                  onClick={() => history.push(product.href)}
                  label={
                    <React.Fragment>
                      <span>{t('action.view')}</span> {/*<ArrowRightOutlined />*/}
                    </React.Fragment>
                  }
                />
              </Col>
              {product?.disablePurchase || product?.stockLimit == 0 ?
                <Col span={12} className="bg-disabled flex-justify-center"
                  style={{ padding: '5px', minHeight: 42 }}>

                  <Button
                    type="transparent"
                    isDisabled={true}
                    label={
                      t('txt.outOfStock')}
                  />
                </Col>
                :
                <Col span={12} className="bg-secondary flex-justify-center"
                  style={{ padding: '5px', minHeight: 42 }}>

                  <Button
                    type="transparent"
                    className="transparent"
                    isDisabled={product?.disablePurchase || product?.stockLimit == 0}
                    label={
                      <React.Fragment>
                        <span>{t('action.buyNow')}</span> {/*<ArrowRightOutlined />*/}
                      </React.Fragment>
                    }
                    onClick={() => onBuyNow(product.productData)}
                  />
                </Col>
              }
            </Row>

          </div>
        </div> : null}

      <BasicModal title="Login" isClosable={true} isMaskClosable={true} isOpen={isOpen}
        onClose={onCloseModal}>
        <LoginForm
          status={loginStatus.login}
          expectedError={loginError}
          onSubmit={handleSubmit}
          onSuccess={() => {
            onCloseModal();
            toaster('success', t('txt.loginSuccess'));
            setLoginStatus({ ...loginStatus, login: 'idle' });
          }}
        />
      </BasicModal>
    </div>
    </>
  )
}

export default ProductListingNew;
